import { lazy } from 'react';
// project import
import Loadable from '../../components/Loadable';
import MissionService from 'services/mission/MissionService';
import MissionConfig from 'pages/mission/config/forms/MissionConfig';
import { Mission } from 'models/mission/Mission';
import AddMissionPage from 'pages/mission/AddMissionPage';
import EditMissionPage from 'pages/mission/EditMissionPage';

// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| ROUTES ITEMS - MISSION ||============================== //

// render - MISSIONS
const Missions = Loadable(
    lazy(() => import('../../pages/mission/MissionPage')),
);

const mission = {
    path: 'mission',
    element: (
        // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
        <Missions />
        // </RequireAuthorizedAccess>
    ),
    children: [
        {
            index: true,
        },
        {
            path: 'create',
            element: (
                <AddMissionPage
                    navigateTo={'/mission'}
                    service={MissionService}
                    pageTitle="Create Mission"
                    config={MissionConfig}
                    slice={'mission'}
                    entity={Mission}
                />
            ),
        },
        {
            path: 'edit/:id',
            element: (
                <EditMissionPage
                    navigateTo={'/mission'}
                    service={MissionService}
                    pageTitle="Edit Mission"
                    config={MissionConfig}
                    slice={'mission'}
                    entity={Mission}
                />
            ),
        },
    ],
};

export default mission;
